
<app-autoredirect></app-autoredirect>
<main [@routerTransition]="getState(o)">
  <router-outlet #o="outlet"></router-outlet>
</main>

